
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 15.875 15.875","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M60.872 1.983v.603","fill":"none"}}),_c('g',{attrs:{"stroke-width":".703","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M7.937.884a4.213 4.213 0 10.001 8.427A4.213 4.213 0 007.937.884zm0 .26a3.953 3.953 0 110 7.907 3.953 3.953 0 010-7.907z","fill":"none","stroke":"#000","stroke-width":".57363508","stroke-miterlimit":"10"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M7.41 2.622h1.055v3.339H7.41zM7.41 6.575h1.055v1.01H7.41z"}})]),_c('g',{attrs:{"fill":"#00000f"}},[_c('path',{attrs:{"d":"M12.552 15.277l-3.798-2.5 3.798-2.5z","opacity":".99"}}),_c('path',{attrs:{"opacity":".99","d":"M12.53 11.575h3.057v2.405H12.53zM3.323 15.277l3.798-2.5-3.798-2.5z"}}),_c('path',{attrs:{"opacity":".99","d":"M3.344 11.575H.288v2.405h3.056zM7.484 10.74h.905v4.075h-.905z"}})])])
          )
        }
      }
    